import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { formatNumber } from "../../../../../../libs/common";

type PropType = {
  data: { date: string; request: number }[];
};
function LineCharts({ data }: PropType) {
  const yAxisFormatter = (value: number) => {
    return formatNumber(value); // Apply the number formatting
  };
  return (
    <div
      style={{
        width: "100%",
        height: 300,
        backgroundColor: "#fff",
      }}
    >
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data}>
          <XAxis dataKey="date" tickLine={false} />
          <YAxis
            axisLine={false}
            tickLine={false}
            tickFormatter={yAxisFormatter}
          />
          <Tooltip />
          <Line
            type="monotone"
            dataKey="request"
            stroke="#D52B1E"
            strokeWidth={2}
            dot={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}

export default LineCharts;
